/* eslint-disable */
/**
 * Creates a universal Proxy that safely wraps any object.
 * If the target is undefined, accessing any property returns another proxy,
 * making it safe to use browser APIs during SSR.
 */
const createProxy = (target) => new Proxy({}, {
    get: (_, prop) => {
        if (!target)
            return undefined;
        const value = target[prop];
        return typeof value === "function"
            ? value.bind(target)
            : value !== null && value !== void 0 ? value : createProxy();
    },
    apply: (_, __, args) => typeof target === "function" ? target(...args) : undefined,
});
/**
 * Creates a StorageHelper that wraps localStorage/sessionStorage safely.
 */
export const createStorageHelper = (storage) => {
    var _a;
    return ({
        getItem: (key) => { var _a; return (_a = storage === null || storage === void 0 ? void 0 : storage.getItem(key)) !== null && _a !== void 0 ? _a : null; },
        setItem: (key, value) => storage === null || storage === void 0 ? void 0 : storage.setItem(key, value),
        removeItem: (key) => storage === null || storage === void 0 ? void 0 : storage.removeItem(key),
        clear: () => storage === null || storage === void 0 ? void 0 : storage.clear(),
        key: (index) => { var _a; return (_a = storage === null || storage === void 0 ? void 0 : storage.key(index)) !== null && _a !== void 0 ? _a : null; },
        length: (_a = storage === null || storage === void 0 ? void 0 : storage.length) !== null && _a !== void 0 ? _a : 0,
        getJSON: (key) => {
            try {
                const val = storage === null || storage === void 0 ? void 0 : storage.getItem(key);
                return val ? JSON.parse(val) : null;
            }
            catch (_a) {
                return null;
            }
        },
        setJSON: (key, value) => {
            try {
                storage === null || storage === void 0 ? void 0 : storage.setItem(key, JSON.stringify(value));
            }
            catch (_a) { }
        },
    });
};
/**
 * Hook to access browser APIs safely in SSR environments.
 */
export const useBrowserAPI = () => {
    const isClient = typeof window !== "undefined";
    const real = {
        bWindow: isClient ? window : {},
        bDocument: isClient ? document : {},
        bNavigator: isClient ? navigator : {},
        bLocation: isClient ? window.location : {},
        bHistory: isClient ? window.history : {},
        bLocalStorage: isClient
            ? createStorageHelper(window.localStorage)
            : createStorageHelper(),
        bSessionStorage: isClient
            ? createStorageHelper(window.sessionStorage)
            : createStorageHelper(),
        bAlert: isClient ? window.alert.bind(window) : () => { },
        bPrompt: isClient ? window.prompt.bind(window) : () => null,
        bConfirm: isClient ? window.confirm.bind(window) : () => false,
        bFile: isClient ? File : {},
        bFileReader: isClient ? FileReader : {},
        bBlob: isClient ? Blob : {},
        bImage: isClient ? Image : {},
        bCustomEvent: isClient
            ? CustomEvent
            : {},
        bEvent: isClient ? Event : {},
        bHTMLElement: isClient
            ? HTMLElement
            : {},
    };
    // Wrap all real objects with a Proxy to make access safe in SSR
    return Object.assign(Object.assign({}, real), { bWindow: createProxy(real.bWindow), bDocument: createProxy(real.bDocument), bNavigator: createProxy(real.bNavigator), bLocation: createProxy(real.bLocation), bHistory: createProxy(real.bHistory), bLocalStorage: createProxy(real.bLocalStorage), bSessionStorage: createProxy(real.bSessionStorage) });
};
